import React, { useState, useEffect } from 'react';
import { useOrg } from '../../hooks/useOrg';
import { db } from '../../firebase';
import { doc, getDoc, updateDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useNotifications } from '../NotificationSystem';
const LabSettingsManager = () => {
  const { activeOrgId } = useOrg();
  const { notify } = useNotifications();
  const [nextRequestId, setNextRequestId] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!activeOrgId) return;
    const seqRef = doc(db, 'org_sequences', activeOrgId);
    getDoc(seqRef).then((snap) => {
      const val = snap.exists() ? (snap.data().lab_next_request_id || 1) : 1;
      setNextRequestId(val);
      setInputValue(String(val));
    }).catch(console.warn).finally(() => setLoading(false));
  }, [activeOrgId]);

  const handleSave = async () => {
    const val = parseInt(inputValue, 10);
    if (Number.isNaN(val) || val < 1) {
      notify.error('Valoare invalidă — trebuie să fie un număr pozitiv');
      return;
    }
    if (!activeOrgId) return;
    setSaving(true);
    try {
      const seqRef = doc(db, 'org_sequences', activeOrgId);
      const snap = await getDoc(seqRef);
      if (snap.exists()) {
        await updateDoc(seqRef, { lab_next_request_id: val, updated_at: serverTimestamp() });
      } else {
        await setDoc(seqRef, {
          organization_id: activeOrgId,
          atp_next_id: 1,
          lab_next_request_id: val,
          updated_at: serverTimestamp()
        });
      }
      setNextRequestId(val);
      notify.success('Configurare laborator salvată');
    } catch (err) {
      notify.error(err.message || String(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-section">
      <h3>Configurare Laborator</h3>
      {loading ? <div>Se încarcă...</div> : (
        <div className="form-field">
          <label>Număr de start cereri laborator</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="number"
              min={1}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              style={{ maxWidth: 160 }}
            />
            <button type="button" className="btn btn-primary btn-sm" onClick={handleSave} disabled={saving}>
              {saving ? 'Se salvează...' : 'Salvează'}
            </button>
          </div>
          <p className="field-hint" style={{ fontSize: 12, color: 'var(--color-text-secondary, #6b7280)', marginTop: 6 }}>
            Următoarea cerere de laborator va primi numărul {nextRequestId}.
            Modificați doar la indicația laboratorului extern.
          </p>
        </div>
      )}
    </div>
  );
};

export default LabSettingsManager;
